import {createReducer} from '@reduxjs/toolkit';
import {
  disableCompare,
  enableCompare,
  setFrameRate,
  setLabels,
  setLogo,
} from '../actions/settings.js';
import {trackEvent} from '../analytics.js';

const defaultState = {
  logo: true,
  labels: true,
  frameRate: 1,
  compare: false,
};

export default createReducer(defaultState, builder => {
  builder.addCase(setLogo, (state, {payload}) => {
    state.logo = payload;
  });

  builder.addCase(setLabels, (state, {payload}) => {
    state.labels = payload;
  });

  builder.addCase(setFrameRate, (state, {payload}) => {
    state.frameRate = payload;
  });

  builder.addCase(enableCompare, state => {
    trackEvent('Enabled Compare');
    state.compare = true;
  });

  builder.addCase(disableCompare, state => {
    trackEvent('Disabled Compare');
    state.compare = false;
  });
});
